import React, { useState } from "react";
import { FilterValue, HvFilterGroup } from "@hitachivantara/uikit-react-core";
import { useTranslation } from "react-i18next";
import { CameraFilter } from "lib/api";

import { Data, FiltersData } from "lib/utils/filterUtils";
import useStyles from "./styles";

interface CameraFilterComponent {
  filters?: number[][];
  baseFilter?: CameraFilter[];
  onChange: (value: number[][]) => void;
}

const FilterComponent: React.FC<CameraFilterComponent> = ({
  filters = [],
  baseFilter = [],
  onChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation(["camera", "common"]);
  const [value, setValue] = useState<number[][]>(filters);

  const filtersData: FiltersData[] = [];
  baseFilter.map((f) => {
    const arrData: Data[] = [];
    f.values.map((v, i) => {
      if (v.i18n) {
        return arrData.push({
          id: i,
          name: t(`camera:filter.${v.name}`),
        });
      }
      return arrData.push({
        id: i,
        name: v.name,
      });
    });
    return filtersData.push({
      id: f.name,
      name: t(`camera:filter.${f.name}`),
      data: arrData,
    });
  });

  const onChangeHandler = (event: Event, values: FilterValue) => {
    const newValues = values as number[][];
    setValue(newValues);
    onChange(newValues);
  };

  return (
    <HvFilterGroup
      id="FilterComponent"
      labels={{
        applyLabel: t("common:filter.apply"),
        cancelLabel: t("common:filter.cancel"),
        clearLabel: t("common:filter.clearFilters"),
        placeholder: t("common:filter.filters"),
        searchBoxPlaceholder: t("common:filter.search"),
        selectAll: t("common:filter.all"),
      }}
      value={value}
      filters={filtersData}
      onChange={onChangeHandler}
      className={classes.filter}
    />
  );
};

export default FilterComponent;
